import { environment } from '../../../../environments/environment'
import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core'
import { DataTableDirective } from 'angular-datatables'
import { Subject, Subscription } from 'rxjs'
import { NotificationService } from 'src/app/services/notification.service'
import { Router, ActivatedRoute } from '@angular/router'
import { } from 'google-maps'
import { CompanyService } from '../../../services/company.service'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { MatDialog } from '@angular/material'
import { InventoryService } from 'src/app/services/inventory.service'
import { ImportInventoryError, ImportationOfInventories, InventoryImport, InventoryScheduleList, InventoryScheduleMap } from 'src/app/models/Inventory'
import { DataCsvInventoryComponent } from '../data-csv-inventory/data-csv-inventory.component'
import { PATH } from 'src/app/app.api'
import { HttpClient } from '@angular/common/http'
import * as moment_ from 'moment'
import { getIdentifierName, getLengthTable, getLoggedUser, setLengthTable } from 'src/app/_helpers/LocalStorage'
import { FilterTemplate } from 'src/app/models/Filter'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { ExcelService } from 'src/app/services/excel.service'
import { SearchTruncated, searchTruncatedInventorySchedule } from 'src/app/_helpers/SearchTruncated'
import { InsertDateComponent } from '../../modal/insert-date/insert-date.component'
import { MapView } from '../../map-view/map-view.component'
import { DetailsFromClick, QuestionsFilters } from '../../../models/DetailsFromClick'
import { insertOrRemoveClassInScrollButton, scrollToConteiner } from 'src/app/_helpers/Utils'
import { IItenPositionWithYourPage, getGeneralPositionOfItemSelected, recalculatePagePositionOfItensSelected } from 'src/app/_helpers/InteractionsWithTables'
import { ExportService } from '../../../services/export.service'
import { ColumnMapType, getTableConfiguration, setTableConfiguration, TablesPanel } from 'src/app/_helpers/Table-settings'

@Component({
	selector: 'app-scheduler-inventory',
	templateUrl: './scheduler-inventory.component.html'
})
export class SchedulerInventoryComponent implements OnInit, AfterViewInit {
	public ViewValidation: ViewValidation = new ViewValidation()
	@ViewChild('xlsxRead') public xlsxRead: any
	@ViewChild('imageRead') public imageRead: any
	@ViewChild(DataCsvInventoryComponent) public dataCsvInventoryComponent: DataCsvInventoryComponent
	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	@ViewChild(MapView) public mapView: MapView
	@ViewChild('tableConteiner') public tableConteiner: ElementRef<HTMLDivElement>
	public currentPageTable: number = 0;

	public isAdmin: boolean = false
	public datatableOptions: DataTables.Settings = {}
	public refreshTable: Subject<any> = new Subject()
	public inventorys: Array<InventoryScheduleList>
	public inventoryScheduler: Array<InventoryScheduleList> = []
	public inventorySchedulerMany: Array<string> = []
	public inventorySchedulerSelectedForMapView: Array<string> = []
	public idMongoInventorySelected: string
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()
	public schedulerEnabled: boolean = false
	public companyIsActive: boolean = false
	public pageIndex = 0

	public checkedActionOperation: boolean = false
	public checkedActionEvaluation: boolean = false
	public modalDetailsOpen: boolean = false
	public filterClicked: boolean = false
	public filterText: string
	public dataTableParams: any
	public dateStart: string = ''
	public dateEnd: string = ''
	public statusFilter: string = ''
	public skip: any
	public limit: any
	public order: any
	public typeOrder: any
	public inputSelected: FilterTemplate = { type: 'PLACEHOLDER', title: 'TODAS' }
	public filterData: Array<FilterTemplate> = [
		{ type: 'PLACEHOLDER', title: 'TODAS' },
		{ type: 'NONE', title: 'AGENDAR' },
		{ type: 'PENDING', title: 'PENDENTE' },
		{ type: 'CANCELED', title: 'CANCELADO' },
		{ type: 'DELAYED', title: 'ATRASADO' }
	]

	public updateDataTable = value => this.filterHeader(value)

	public identifierName = getIdentifierName()
	public selectAllActive: boolean = true
	public importError: Array<ImportInventoryError> = []
	public importationOfInventories: Array<ImportationOfInventories> = []
	public openModalShowError: boolean = false
	public openModalShowImports: boolean = false

	public inventoryScheduleSearchTruncated: Array<SearchTruncated> = searchTruncatedInventorySchedule
	public searchTruncatedStringFormated: string = ''

	public inventoryPins: Array<InventoryScheduleMap> = []
	public pinFilters: QuestionsFilters
	public inventorySelectedFromTable: DetailsFromClick = new DetailsFromClick()
	public pinsForMap: Array<any>
	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()
	public showOnlySelected: boolean = false
	public generalPositionOfItensSelected: Array<IItenPositionWithYourPage> = []
	public pagesWithItensSelected: Array<number> = []
	public settingsTable: ColumnMapType = getTableConfiguration(TablesPanel.SCHEDULE_INVENTORY);
	public showSetTable: boolean = false;
	public httpListSubscription: Subscription

	constructor(
		private router: Router,
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute,
		private inventoryService: InventoryService,
		private companyService: CompanyService,
		public dialog: MatDialog,
		private http: HttpClient,
		private readonly excelService: ExcelService,
		private readonly exportService: ExportService
	) { }

	public async ngOnInit(): Promise<void> {
		localStorage.removeItem('operationService')
		localStorage.removeItem('demand')
		localStorage.removeItem('inventories')
		localStorage.removeItem('cameFromScheduleMap')

		this.filterText =
			this.activateRoute.snapshot.queryParams.search ?
			this.activateRoute.snapshot.queryParams.search : ''

		this.setupDatatables()
		this.checkCompanyStatus()
		this.fetchUserAssignments()
		await this.setupDatatables()
		await this.checkCompanyStatus()
		await this.fetchUserAssignments()
		await this.getInventoryScheduleMap()
		await this.getInventoryScheduleMapFilters()
		if (this.isAdmin) {
			await this.fetchImportationsOfInventories()
		}
		this.rerender()

		const observer =
			new IntersectionObserver( ([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	private async getInventoryScheduleMap(): Promise<void> {
		this.inventoryPins =
			await this.inventoryService
			.getInventoryScheduleMap(this.companyId)
			.toPromise()
	}

	private async getInventoryScheduleMapFilters(): Promise<void> {
		this.pinFilters = await this.inventoryService
			.getInventoryScheduleMapFilters(this.companyId)
			.toPromise()
	}

	public async updateMapCache() {
		this.inventoryPins =
			await this.inventoryService.updateScheduleMapCache(this.companyId).toPromise()
	}

	public async updateLocationPin(data: any) {
		await this.inventoryService.updateLocationPinScheduleMapHistory(
			data.idMongo,
			data.location
		).toPromise()
	}

	private async getInventoryScheduleFromTable(treeId: string): Promise<void> {
		const mapBody = document.getElementsByClassName('map-content')[0]

		mapBody.scrollIntoView({
			behavior: 'smooth'
		})

		const selectedTree =
			await this.inventoryService.getScheduleTreeInfos(treeId, this.companyId).toPromise()

		selectedTree.idMongo = treeId

		this.inventorySelectedFromTable = selectedTree
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			pagingType: 'full_numbers',
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			paging: true,
			searching: true,
			ordering: true,
			destroy: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: [4],
					width: '.1%'
				}
			],
			order: [[4, 'desc']],
			orderMulti: true,
			serverSide: true,

			ajax: (dataTablesParameters: any, callback) => {
				this.skip = dataTablesParameters.start
				this.limit = dataTablesParameters.length
				this.order = dataTablesParameters.columns[dataTablesParameters.order[0].column].data
				this.typeOrder = dataTablesParameters.order[0].dir
				if (this.httpListSubscription) {
					this.httpListSubscription.unsubscribe()
				}
				this.httpListSubscription = this.http
					.get<any>(`${PATH}/inventorys/all?companyId=${this.companyId}&skip=${dataTablesParameters.start}&limit=${dataTablesParameters.length}&order=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}&typeOrder=${dataTablesParameters.order[0].dir}&search=${this.filterText}&dateStart=${this.dateStart}&dateEnd=${this.dateEnd}&status=${this.statusFilter}${this.searchTruncatedStringFormated && this.searchTruncatedStringFormated}${this.showOnlySelected ? '&onlySelected=true&itensSelected=' + this.inventorySchedulerMany : ''}`)
					.subscribe(resp => {
						this.inventorys = resp.content
						this.currentPageTable = Math.floor(dataTablesParameters.start / dataTablesParameters.length)
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
						this.switchSelectAllButton(true)
					})
			},
			columns: [
				{ data: 'actions', orderable: false },
				{ data: 'select' , orderable: false },
				{ data: 'identifier' },
				{ data: 'treeId' },
				{ data: 'data' },
				{ data: 'address' },
				{ data: 'generalState' , orderable: false},
				{ data: 'management' , orderable: false},
				{ data: 'operation' , orderable: false },			
				{ data: 'serviceOrder' },
				{ data: 'schedule' },
				{ data: 'inventor' },
			]
		}
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()

			this.companyIsActive = Boolean(companyStatus === 'ACTIVE')
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public fetchUserAssignments(): void {
		this.schedulerEnabled = Boolean(
			this.sessionUser.assignments.includes('INVENTORY_SCHEDULE_CREATE')
		)

		this.isAdmin = this.sessionUser.roles.includes('GENERAL_ADMIN')
	}

	public async fetchImportationsOfInventories() {
		this.importationOfInventories =
			await this.inventoryService.fetchImportationOfInventories(this.companyId).toPromise()
	}

	public async getInventorySchedule(): Promise<void> {
		this.modalDetailsOpen = false

		this.rerender()
	}

	public selectedManysInventorysSchedule(inventory: InventoryScheduleList) {
		const index = this.inventorySchedulerMany.indexOf(inventory.idMongo)

		if (index > -1) {
			this.inventorySchedulerMany.splice(index, 1)

			let indexInventory = 0
			this.inventoryScheduler.map((inventory, index) => {
				if (inventory.idMongo == inventory.idMongo) {
					indexInventory = index
				}
			})
			this.inventoryScheduler.splice(indexInventory, 1)
		} else {
			this.inventorySchedulerMany.push(inventory.idMongo)
			this.inventoryScheduler.push(inventory)
		}

		this.switchSelectAllButton()
	}

	public setInventoriesSelectedForMapView(idMongo: string) {
		const index = this.inventorySchedulerSelectedForMapView.indexOf(idMongo)

		if (index > -1) {
			this.inventorySchedulerSelectedForMapView.splice(index, 1)
		} else {
			this.inventorySchedulerSelectedForMapView.push(idMongo)
		}

		this.interactWithMap()
	}

	public interactWithMap() {
		if (this.mapView) {
			this.mapView.changeViewPinsFromMap(true)
			this.mapView.enableOrDisableShowOnlySelectButton()
		}
	}

	public filterHeader(value: any): void {
		const isData = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
		if (isData.test(value)) {
			this.dateStart = moment_(value, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
			this.dateEnd = moment_(value, 'DD/MM/YYYY').add('days', 1).format(
				'YYYY-MM-DD'
			)
		} else {
			this.dateStart = ''
			this.dateEnd = ''
			this.filterText = value
		}
		this.clearSelections()
		this.rerender()
	}

	public onFilterOpen(): void {
		this.filterClicked = !this.filterClicked
	}

	public onFilter(filter: FilterTemplate): void {
		this.inputSelected = filter
		this.filterClicked = !this.filterClicked
		this.applyFilterStatus(filter.title)
	}

	public applyFilterStatus(value: string) {
		switch (value) {
			case 'TODAS':
				this.statusFilter = ''
				break
			case 'CANCELANDO':
				this.statusFilter = 'AGUARDANDO'
				break
			default:
				this.statusFilter = value
				break
		}

		this.clearSelections()
		this.rerender()
	}

	public schedulerInventory(inventory: InventoryScheduleList) {
		if (!this.companyIsActive) return

		const inventoriesToUpdate = []
		if (inventory) {
			inventoriesToUpdate.push(inventory)
		} else {
			inventoriesToUpdate.push(...this.inventoryScheduler)
		}

		localStorage.setItem('inventories', JSON.stringify(inventoriesToUpdate))
		this.router.navigate(['/panel/inventory/pre-schedule'])
	}

	public openModal(inventoryId: string): void {
		if (!this.companyIsActive) return

		this.modalDetailsOpen = true
		this.idMongoInventorySelected = inventoryId
	}

	public closeModal() {
		this.modalDetailsOpen = false
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()

				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public openModalImages($event: any): void {
		this.dataCsvInventoryComponent.listImagesForUser($event)
	}

	public async onFileSelected($event) {

		const file: File = $event.srcElement.files[0]

		if (!file) return

		this.fileResetCsv()

		this.excelService.readFileXlsxAndReturnArrayObjects<InventoryImport>(file, InventoryImport).toPromise()
			.then(data => {
				return this.dataCsvInventoryComponent.readFileXlms(data)
			})
			.catch(error => {
				if (error.length > 0) {
					this.importError = error
					this.openModalShowError = true
				}
			})
	}

	public closeModalShowError() {
		this.openModalShowError = false
	}

	public openCloseModalShowImports(open: boolean) {
		this.openModalShowImports = open
	}

	public async revertImportation(id: number) {

		this.notificationService.initLoading()

		try {
			const response =
				await this.inventoryService.removeImportation(id).toPromise()

			this.notificationService.notify(response, 200)

			await this.fetchImportationsOfInventories()
		} catch (error) {
			this.notificationService.notify('Erro ao reverter importação', 500)
		}

		this.notificationService.stopLoading()
		await this.fetchImportationsOfInventories()
		await this.getInventorySchedule()
	}

	public fileResetCsv() {
		this.xlsxRead.nativeElement.value = ''
	}

	public fileResetImage() {
		this.imageRead.nativeElement.value = ''
	}

	public selectOrUnselectAllItens() {
		if (this.selectAllActive) {
			this.selectAllItensForList()
		} else {
			this.unselectAllItensForLIst()
		}
	}

	public selectAllItensForList() {
		this.inventorys.forEach((item, i) => {
			if (
				!this.inventorySchedulerMany.includes(item.idMongo) &&
				(item.status == 'AGENDAR' || item.status == 'CANCELADO')
			) {
				this.inventorySchedulerMany.push(item.idMongo)
				this.inventoryScheduler.push(item)
			}

			/*
				Se o inventário ainda não estiver dentro do Array para visualização de PIN's
				no mapa
			*/
			if (!this.inventorySchedulerSelectedForMapView.includes(item.idMongo)) {
				this.inventorySchedulerSelectedForMapView.push(item.idMongo)
			}

			this.setGeneralPositionItenSelected(i, true, false)
		})

		this.selectAllActive = false
	}

	public unselectAllItensForLIst() {
		this.inventorys.forEach((item, i) => {
			const index = this.inventorySchedulerMany.indexOf(item.idMongo)

			if (index != -1) {
				this.inventorySchedulerMany.splice(index, 1)
			}

			const indexScheduler =
				this.inventoryScheduler.findIndex(inventory => inventory.idMongo === item.idMongo)

			if (indexScheduler != -1) {
				this.inventoryScheduler.splice(indexScheduler, 1)
			}

			const indexMap = this.inventorySchedulerSelectedForMapView.indexOf(item.idMongo)

			if (indexMap != -1) {
				this.inventorySchedulerSelectedForMapView.splice(indexMap, 1)
			}
			this.setGeneralPositionItenSelected(i, false, true)
		})

		this.selectAllActive = true
	}

	public switchSelectAllButton(active?: boolean) {

		const itensIds: Array<string> = []

		this.inventorys.forEach(item => {
			if (item.status == 'AGENDAR' || item.status == 'CANCELADO') {
				itensIds.push(item.idMongo)
			}
		})

		const allItensSelected: boolean = itensIds.every(item => this.inventorySchedulerMany.includes(item))
		const allItensUnSelected: boolean = itensIds.every(item => !this.inventorySchedulerMany.includes(item))

		if (allItensSelected) {
			this.selectAllActive = false
			return
		} else if (allItensUnSelected) {
			this.selectAllActive = true
			return
		}

		if (active) {
			this.selectAllActive = active
		}
	}

	public searchTruncated(value: string) {
		this.searchTruncatedStringFormated = value
		this.clearSelections()
		this.rerender()
	}

	public async exportAsXLSXInventorys() {

		const dialogRef = this.dialog.open(InsertDateComponent)
		dialogRef.componentInstance.close = dialogRef.close
		let dateStart: number
		let dateEnd: number

		dialogRef.afterClosed().subscribe(async result => {
			if (!dialogRef.componentInstance.cancel) {
				let dateAux = dialogRef.componentInstance.dateStart.split('/')
				dateStart = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
				dateAux = dialogRef.componentInstance.dateEnd.split('/')
				dateEnd = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
			}
			if (!dateStart || !dateEnd) return

			if (this.isAdmin) {
				await this.inventoryService.getExportInventorysSchedule(
					this.companyId,
					dateStart,
					dateEnd,
					this.sessionUser.roles
				).toPromise()
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
				return
			}

			const diffMonths = (dateEnd - dateStart) / (1000 * 60 * 60 * 24 * 30)

			if (diffMonths > 3 ) {
				this.notificationService.notify('O período de exportação excede o limite de 3 meses. Entre em contato com o administrador do sistema', 404)
				return
			}

			if (diffMonths > 1) {
				this.notificationService.notify('O período de exportação solicitado é de um mês ou mais, o arquivo será enviado para o seu email', 200)
				await this.exportService.sendExportByEmail({type: 'inventory-schedule', dateEnd, dateStart}).toPromise()
			} else {
				await this.inventoryService.getExportInventorysSchedule(
					this.companyId,
					dateStart,
					dateEnd,
					this.sessionUser.roles
				).toPromise()
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
			}
		})
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.rerender()
		setLengthTable(newLength)

		const newGeneralPositionItem = recalculatePagePositionOfItensSelected(
			Number(newLength),
			this.generalPositionOfItensSelected
		)
		this.generalPositionOfItensSelected = newGeneralPositionItem.allItensSelected
		this.pagesWithItensSelected = newGeneralPositionItem.allPagesSelected
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}

	public viewOnlySelected() {
		this.showOnlySelected = !this.showOnlySelected

		this.rerender()
	}

	public setGeneralPositionItenSelected(
		indexInCurrentPage: number,
		selectingAll: boolean,
		unSelectingAll: boolean
	) {
		const generalPositionItem = getGeneralPositionOfItemSelected(
			indexInCurrentPage + 1,
			Number(this.lengthTable),
			this.generalPositionOfItensSelected,
			selectingAll,
			unSelectingAll,
			this.currentPageTable
		)
		this.generalPositionOfItensSelected = generalPositionItem.allItensSelected
		this.pagesWithItensSelected = generalPositionItem.allPagesSelected
	}

	public clearSelections() {
		this.inventorySchedulerMany = []
		this.inventoryScheduler = []
		this.inventorySchedulerSelectedForMapView = []
		this.generalPositionOfItensSelected = []
		this.pagesWithItensSelected = []
	}

	public openSetTable() {
		this.showSetTable = !this.showSetTable;
	}

	public setNewTableConfig(configColumns: ColumnMapType) {
		this.settingsTable = configColumns;
		setTableConfiguration(TablesPanel.SCHEDULE_INVENTORY, configColumns);
		this.openSetTable();
	}
}
